<template>
    <div class="wrapper">
        <notifications position="bottom center" class="custom-notifications" classes="toast-notification" > 
            <template slot="body" slot-scope="props">
                <div :class="['notification toast-notification', props.item.type]" @click="props.close">
                    <a class="notification-title">{{ props.item.title }}</a>
                    <p class="notification-content" v-html="props.item.text"></p>
                </div>
            </template>
        </notifications>

        <router-view/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from './Footer'
    import ContentWrapper from './ContentWrapper'

    Vue.component('ContentWrapper', ContentWrapper)

    export default {
        name: 'Layout',
        components: {
            Footer
        }
    }
</script>